module.exports = __webpack_public_path__ + "images/email/bg-active-1-9eed9fdeddb4bcba4d475e6f86206541.png";